import AsyncStorage from 'localforage'
import { createApolloClient as createApolloClientBase } from '@vivaldis/common'
import { sessionSelector, invalidate, UserType } from '@vivaldis/session'
import { tracking } from '@vivaldis/tracking'
import { typePolicies } from '@vivaldis/graphql'

export function createApolloClient() {
  return createApolloClientBase({
    storage: AsyncStorage,
    sessionSelector: sessionSelector,
    tracking: tracking,
    userType: UserType.SuperUser,
    apiUrl: import.meta.env.VITE_API_URL as string,
    appVersion: `${import.meta.env.VITE_VERSION}`,
    invalidate: invalidate,
    apolloClientOptions: {
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'cache-and-network'
        }
      }
    },
    apolloInMemoryCacheConfig: {
      typePolicies
    }
  })
}
